"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActionSpinsView = void 0;
const FeatureBasePanel_1 = require("../FeatureBasePanel");
const PromoPanelAssetConfig_1 = require("../../config/PromoPanelAssetConfig");
const NolimitPromotionPlugin_1 = require("../../NolimitPromotionPlugin");
const PromoPanelLabelIDs_1 = require("../../enums/PromoPanelLabelIDs");
const PromoPanelTextStyles_1 = require("../../config/PromoPanelTextStyles");
const ActionSpinsController_1 = require("./ActionSpinsController");
const NolimitApplication_1 = require("@nolimit/slot-launcher/bin/NolimitApplication");
const Helper_1 = require("../../utils/Helper");
const PromoPanelConfig_1 = require("../../config/PromoPanelConfig");
const PromoPanelButtonIDs_1 = require("../../enums/PromoPanelButtonIDs");
const ActionSpinsBuyFeatureController_1 = require("./buyFeature/ActionSpinsBuyFeatureController");
const BonusFeatures_1 = require("@nolimit/slot-launcher/bin/plugins/apiplugin/BonusFeatures");
const ActionSpinMainGameView_1 = require("./ActionSpinMainGameView");
const ASStopSettings_1 = require("./settings/ASStopSettings");
const ASEnums_1 = require("../../enums/ASEnums");
const PromoPanelEvents_1 = require("../../events/PromoPanelEvents");
const ASBetPanelView_1 = require("./ASBetPanelView");
const ImgLoader_1 = require("@nolimit/slot-launcher/bin/loader/ImgLoader");
const ASGameOptionsView_1 = require("./subViews/ASGameOptionsView");
const ASTopMenuToggleButton_1 = require("./subViews/ASTopMenuToggleButton");
class ActionSpinsView extends FeatureBasePanel_1.FeatureBasePanel {
    get buyFeatureController() {
        return this._buyFeatureController;
    }
    get mainGameView() {
        return this._mainGameView;
    }
    get gameOptionsView() {
        return this._gameOptionsView;
    }
    constructor(controller, scroll) {
        super(PromoPanelAssetConfig_1.PromoPanelAssetConfig.ACTION_SPINS_ICON, NolimitPromotionPlugin_1.NolimitPromotionPlugin.apiPlugIn.translations.translate(PromoPanelLabelIDs_1.PromoPanelLabelIDs.ACTION_SPINS), PromoPanelTextStyles_1.PromoPanelTextStyles.FEATURE_ACTION_SPIN_REPLAY_TITLE);
        this._currentState = "";
        this.stopOnBonusCallback = (stopOnBonus) => {
            switch (this._currentState) {
                case PromoPanelButtonIDs_1.PromoPanelButtonIDs.ACTION_SPINS_MAIN_GAME:
                    this._gameOptionsView.enableBonusOption(!stopOnBonus);
                    break;
                case PromoPanelButtonIDs_1.PromoPanelButtonIDs.ACTION_SPINS_BONUS_BUY:
                    this._gameOptionsView.enableBonusOption(true);
                    break;
            }
            this._controller.onGameOptionUpdate();
        };
        this._controller = controller;
        this._scroll = scroll;
    }
    init() {
        super.init();
        this._wrapper = new PIXI.Container();
        this._wrapper.name = "MAIN_VIEW_WRAPPER";
        this.addChild(this._wrapper);
        this._mainGameView = new ActionSpinMainGameView_1.ActionSpinMainGameView(this._controller);
        this._gameOptionsView = new ASGameOptionsView_1.ASGameOptionsView(NolimitPromotionPlugin_1.NolimitPromotionPlugin.ASOptionsData, this._controller.onGameOptionUpdate);
        this.betPanel = new ASBetPanelView_1.ASBetPanelView(PromoPanelButtonIDs_1.PromoPanelButtonIDs.ACTION_SPINS_BET_UP, PromoPanelButtonIDs_1.PromoPanelButtonIDs.ACTION_SPINS_BET_DOWN, (button) => this._controller.buttonClick(button), ActionSpinsView.ACTIVE_COLOR);
        this.spinsPanel = new ASBetPanelView_1.ASBetPanelView(PromoPanelButtonIDs_1.PromoPanelButtonIDs.ACTION_SPINS_COUNT_UP, PromoPanelButtonIDs_1.PromoPanelButtonIDs.ACTION_SPINS_COUNT_DOWN, (button) => this._controller.buttonClick(button), ActionSpinsView.ACTIVE_COLOR, true);
        this._betAndSpinsContainer = new PIXI.Container();
        this._betAndSpinsContainer.addChild(this.betPanel, this.spinsPanel);
        this._betAndSpinsContainer.name = "betAndSpinsContainer";
        const data = NolimitPromotionPlugin_1.NolimitPromotionPlugin.apiPlugIn.bonusFeatures.allTypesByCategory[BonusFeatures_1.GameFeatureCategory.BONUS_BUY];
        const featureData = NolimitPromotionPlugin_1.NolimitPromotionPlugin.apiPlugIn.bonusFeatures.getFeatureDataByTypes(data);
        this._buyFeatureController = new ActionSpinsBuyFeatureController_1.ActionSpinsBuyFeatureController(this._controller, featureData);
        this._buyFeatureController.createView();
        this._scroll.addContent(this._buyFeatureController.view);
        this._wrapper.addChild(this._logo, this._title); //we need to hide all content when replay view shown.
        this._topBtnContainer = this.createTopButtonContainer();
        this._wrapper.addChild(this._topBtnContainer, this._betAndSpinsContainer, this._gameOptionsView, this._mainGameView);
        this._wrapper.addChild(this._buyFeatureController.view);
        if (!this._controller.promotionPlugin.hasNolimitBonus()) {
            this._topBtnContainer.visible = false;
        }
        this._gameOptionsView.init();
        ActionSpinsController_1.ActionSpinsController.settings.addCallback(ActionSpinsController_1.ActionSpinsController.settings.STOP_ON_BONUS, this.stopOnBonusCallback);
    }
    toggleGameTypeButtons(btnName) {
        var _a, _b;
        if (this._currentState === btnName) {
            return;
        }
        this._currentState = btnName;
        switch (btnName) {
            case PromoPanelButtonIDs_1.PromoPanelButtonIDs.ACTION_SPINS_MAIN_GAME:
                NolimitPromotionPlugin_1.NolimitPromotionPlugin.saveToLocalStorage(ASEnums_1.LocalStorageSettingsKey.AS_BONUS_TAB_SELECTED, false);
                this._bonusBuyViewBtn.toggled = false;
                this._mainGameViewBtn.toggled = true;
                this._mainGameView.visible = true;
                this._gameOptionsView.setVisibleSelectors(true, true, true);
                this.stopOnBonusCallback(ActionSpinsController_1.ActionSpinsController.settings.stopOnBonus);
                this._wrapper.removeChild(this._buyFeatureController.view);
                break;
            case PromoPanelButtonIDs_1.PromoPanelButtonIDs.ACTION_SPINS_BONUS_BUY:
                NolimitPromotionPlugin_1.NolimitPromotionPlugin.saveToLocalStorage(ASEnums_1.LocalStorageSettingsKey.AS_BONUS_TAB_SELECTED, true);
                this._bonusBuyViewBtn.toggled = true;
                this._mainGameViewBtn.toggled = false;
                this._mainGameView.visible = false;
                this.showBonusBuyWindow();
                let showBonusOptions = true;
                if (((_b = (_a = NolimitPromotionPlugin_1.NolimitPromotionPlugin.ASOptionsData) === null || _a === void 0 ? void 0 : _a.bonusGame) === null || _b === void 0 ? void 0 : _b.pickNeededForBuyFeatures) && NolimitPromotionPlugin_1.NolimitPromotionPlugin.ASOptionsData.bonusGame.pickNeededForBuyFeatures.length <= 0) {
                    showBonusOptions = false;
                }
                this._gameOptionsView.setVisibleSelectors(showBonusOptions, false, false);
                this.stopOnBonusCallback(ActionSpinsController_1.ActionSpinsController.settings.stopOnBonus);
                this._wrapper.addChild(this._buyFeatureController.view);
                break;
        }
        this.onResize();
        this._scroll.updateContent();
    }
    onOrientationChanged() {
        this._controller.replayController.view.onOrientationChanged();
    }
    onResize() {
        if (this._isOpen) {
            const bounds = NolimitApplication_1.NolimitApplication.screenBounds;
            const landscapeLayout = NolimitApplication_1.NolimitApplication.isLandscape && Helper_1.Helper.isDefaultScreenRatio(bounds);
            let availableWidth = bounds.width;
            this._scroll.position.set(0, 105);
            const newScrollRect = new PIXI.Rectangle(PromoPanelConfig_1.PromoPanelConfig.PROMO_PANEL_BTN_PANEL_HEIGHT, 0, bounds.width - PromoPanelConfig_1.PromoPanelConfig.PROMO_PANEL_BTN_PANEL_HEIGHT, bounds.height - NolimitPromotionPlugin_1.NolimitPromotionPlugin.keypadPlugin.getBalanceBarHeight() - 1);
            if (landscapeLayout) {
                availableWidth = bounds.width - PromoPanelConfig_1.PromoPanelConfig.PROMO_PANEL_BTN_PANEL_HEIGHT;
            }
            else if (NolimitApplication_1.NolimitApplication.isLandscape && !Helper_1.Helper.isDefaultScreenRatio(bounds)) {
                availableWidth = bounds.width - PromoPanelConfig_1.PromoPanelConfig.PROMO_PANEL_BTN_PANEL_HEIGHT;
            }
            else {
                const topBarHeight = ImgLoader_1.ImgLoader.getImgTexture(PromoPanelAssetConfig_1.PromoPanelAssetConfig.TOP_BAR).height - 10;
                newScrollRect.width = availableWidth;
                newScrollRect.height = bounds.height - NolimitPromotionPlugin_1.NolimitPromotionPlugin.keypadPlugin.getBalanceBarHeight() - topBarHeight - PromoPanelConfig_1.PromoPanelConfig.PROMO_PANEL_BTN_PANEL_HEIGHT;
                newScrollRect.x = 0;
                newScrollRect.y = topBarHeight;
            }
            this._scroll.resize(newScrollRect.width, newScrollRect.height);
            this._scroll.position.set(newScrollRect.x, newScrollRect.y);
            this.position.set(0, 0);
            super.onResize();
            this.buyFeatureController.view.onResize();
            this._scroll.updateContent();
            const margin = 7;
            this._topBtnContainer.position.set(availableWidth * 0.5, 190);
            this.betPanel.resize(landscapeLayout);
            this.betPanel.pivot.set(this.betPanel.width * 0.5, 0);
            this.spinsPanel.resize(landscapeLayout);
            this.spinsPanel.pivot.set(this.spinsPanel.width * 0.5, 0);
            this.spinsPanel.position.set(0, this.betPanel.height + margin);
            let yAdvance = this._topBtnContainer.visible ? 260 : 145;
            this._betAndSpinsContainer.position.set(availableWidth * 0.5, yAdvance);
            yAdvance += this._betAndSpinsContainer.height;
            yAdvance += margin * 2;
            this._gameOptionsView.position.set(availableWidth * 0.5, yAdvance);
            this._gameOptionsView.pivot.set(this.betPanel.width * 0.5, 0);
            yAdvance += this._gameOptionsView.height;
            yAdvance += margin * 4;
            //BUY FEATURE
            this.buyFeatureController.view.y = yAdvance;
            //OR MAIN GAME
            this._mainGameView.resize(landscapeLayout);
            this._mainGameView.position.set(availableWidth * 0.5, yAdvance);
            this._controller.replayController.view.onResize();
        }
    }
    onUpdateBuyFeaturePrice(currentBet) {
        if (this._bonusBuyViewBtn.toggled) {
            return this._buyFeatureController.view.updateFeaturePrice(currentBet);
        }
        else {
            return 0;
        }
    }
    getNextBetMinFeaturePrice(nextCurrentBet, currentSpinCount) {
        return this._buyFeatureController.view.getNextBetMinFeaturePrice(nextCurrentBet, currentSpinCount);
    }
    open() {
        super.open();
        this.showWrapper();
        this.toggleGameTypeButtons(NolimitPromotionPlugin_1.NolimitPromotionPlugin.getFromLocalStorage(ASEnums_1.LocalStorageSettingsKey.AS_BONUS_TAB_SELECTED, false) ? this._bonusBuyViewBtn.name : this._mainGameViewBtn.name);
        this._controller.onGameOptionUpdate();
        this._scroll.visible = true;
        this.enableScroll(true);
        this._scroll.updateContent();
    }
    close() {
        super.close();
        ASStopSettings_1.ASStopSettings.reset();
        this.enableScroll(false);
        this._scroll.visible = false;
        this._buyFeatureController.close();
        this._currentState = "";
    }
    disableBetButtons() {
        this.betPanel.betSelector.enableUpButton(false);
        this.betPanel.betSelector.enableDownButton(false);
    }
    onBetChange(bet) {
        this.gameOptionsView.onUpdateBet();
        this.betPanel.setValue(+bet);
    }
    setBet(value) {
        this.betPanel.setValue(+value);
    }
    getBet() {
        return this.betPanel.getValue();
    }
    showBonusBuyWindow() {
        this._buyFeatureController.open();
    }
    closeBonusBuyWindow() {
        this._buyFeatureController.close(true);
        this._scroll.updateContent();
    }
    hideWrapper() {
        this._wrapper.visible = false;
        this._scroll.updateContent();
    }
    showWrapper() {
        this._wrapper.visible = true;
        if (this._bonusBuyViewBtn.toggled) {
            this.showBonusBuyWindow();
        }
        this._scroll.reAddMouseHoverListener();
        this._scroll.updateContent();
    }
    enableScroll(value) {
        this._scroll.scrollEnabled = value;
    }
    enableASMainTab() {
        this._controller.updateStartButtonState();
        NolimitApplication_1.NolimitApplication.events.trigger(PromoPanelEvents_1.PromoPanelEvents.TOGGLE_BUTTONS_ON_LIGHTING_SPINS, true);
    }
    createTopButtonContainer() {
        const container = new PIXI.Container();
        this._mainGameViewBtn = this.createToggleButton(PromoPanelButtonIDs_1.PromoPanelButtonIDs.ACTION_SPINS_MAIN_GAME, PromoPanelLabelIDs_1.PromoPanelLabelIDs.ACTION_SPINS_MAIN_GAME_LABEL);
        this._bonusBuyViewBtn = this.createToggleButton(PromoPanelButtonIDs_1.PromoPanelButtonIDs.ACTION_SPINS_BONUS_BUY, PromoPanelLabelIDs_1.PromoPanelLabelIDs.ACTION_SPINS_BONUS_BUY_LABEL);
        const separator = new PIXI.Sprite(PIXI.Texture.WHITE);
        separator.anchor.set(0.5, 0.5);
        separator.tint = 0xf57f20;
        separator.height = 90;
        separator.width = 2;
        this._mainGameViewBtn.position.set(-this._mainGameViewBtn.width * 0.5 - 37, 0);
        this._bonusBuyViewBtn.position.set(this._bonusBuyViewBtn.width * 0.5 + 37, 0);
        container.name = "TOP_BUTTON_CONTAINER";
        container.addChild(this._mainGameViewBtn, separator, this._bonusBuyViewBtn);
        return container;
    }
    createToggleButton(id, labelString) {
        const translatedLabel = NolimitPromotionPlugin_1.NolimitPromotionPlugin.apiPlugIn.translations.translate(labelString);
        const btn = new ASTopMenuToggleButton_1.ASTopMenuToggleButton(id, translatedLabel);
        btn.addClickCallback(() => {
            this.toggleGameTypeButtons(btn.name);
            NolimitPromotionPlugin_1.NolimitPromotionPlugin.sound.playKeypadEffect("click");
        });
        btn.toggled = false;
        btn.enable(true);
        btn.pivot.set(btn.width * 0.5, btn.height * 0.5);
        return btn;
    }
}
ActionSpinsView.ACTIVE_COLOR = PIXI.utils.string2hex("#f57f20");
exports.ActionSpinsView = ActionSpinsView;
//# sourceMappingURL=ActionSpinsView.js.map